module.exports = __webpack_public_path__ + "img/instagram.112df6ad.png";